<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import TaskList from './TaskList';

export default {
  name: 'TaskWidget',
  components: {
    TaskList,
  },
  data() {
    return {
      myTasks: [],
      allTasks: [],
      currentUserId: null,
    };
  },
  computed: {
    ...mapGetters('taskList', ['list']),
  },
  watch: {
    list: {
      handler() {
        let tasks = this.list;
        const tempAllTasks = [];

        if (!tasks) tasks = [];

        tasks = tasks.filter(it => !it.isDelete
          && typeof it.status !== 'undefined'
          && it.status !== 2
          && it.priority !== 3);
        console.log('tasks.size() list', tasks.length);

        for (let i = 0; i < tasks.length; i += 1) {
          const task = tasks[i];

          tempAllTasks.push({
            id: task.id,
            name: task.name,
            description: task.description,
            priority: task.priority,
            status: task.status,
            deadline: task.deadline,
            closed: false,
            user: task.user,
            notes: task.notes,
            resubmission: task.resubmission,
          });
        }
        this.allTasks = tempAllTasks;

        if (this.currentUserId) {
          this.myTasks = this.filterMyTasks(tasks);
        } else {
          axios.get('/user/showCurrent').then((response) => {
            this.currentUserId = response.data.id;
            this.myTasks = this.filterMyTasks(tasks);
          });
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    ...mapActions('taskList', ['getAll']),
    fetchData() {
      this.getAll();
    },
    filterMyTasks(tasks) {
      const tempMyTasks = [];

      for (let i = 0; i < tasks.length; i += 1) {
        const task = tasks[i];

        if (task.user && task.user.id === this.currentUserId) {
          tempMyTasks.push(task);

          tempMyTasks.push({
            id: task.id,
            name: task.name,
            description: task.description,
            priority: task.priority,
            status: task.status,
            deadline: task.deadline,
            closed: false,
            user: task.user,
            notes: task.notes,
            resubmission: task.resubmission,
          });
        }
      }

      return tempMyTasks;
    },
    toggle(index) {
      const i = this.inwork.indexOf(index);

      if (i > -1) {
        this.inwork.splice(i, 1);
      } else {
        this.inwork.push(index);
      }
    },
    openAufgaben() {
      this.$router.push('/tasks');
    },
    updateTasks() {
      this.fetchData();
    },
  },
};
</script>

<template>
  <div>
    <v-card>
      <v-card-title class="cursor-pointer" @click="openAufgaben">
        <v-icon large left>
          check
        </v-icon>
        <span class="title"> Aufgaben </span>
      </v-card-title>

      <v-tabs color="#fff" slider-color="#26a73a">
        <v-tab ripple>
          Meine Aufgaben
        </v-tab>

        <v-tab ripple>
          Alle Aufgaben
        </v-tab>

        <v-tab-item>
          <v-card>
            <v-list two-line>
              <task-list :tasks="myTasks" @taskListUpdate="updateTasks"/>
            </v-list>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat>
            <task-list :tasks="allTasks" @taskListUpdate="updateTasks"/>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
